module.exports = __webpack_public_path__ + "img/place1.ae39d80d.jpg";